import React, {useState} from "react"
//import {Link} from "gatsby"
//import Layout from "../components/layout"
import Header from "../components/header"
import Footer from "../components/footer"
import Review from "../components/review"
import CustomerChat from "../components/customerChat"
import MessengerCustomerChat from 'react-messenger-customer-chat';
import ReactDOM from 'react-dom';



//게시판 table


import '../../css/style.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import '../../vendors/animate-css/animate.css'
import '../../vendors/popup/magnific-popup.css'
//after RESET code



//const [isDarkMode, setIsDarkMode] = useState(() => false);


const IndexPage = () => (
	<div id ="page" className="index">
		<Footer />
		<Header />
		<div id="page-wrapper">
			<div id="welcome" className="col-12">
				
				<div className="container">
					<img src="/store.jpg"/>

				</div>
			
			</div>

			<Review />
		</div>

		<div className="blank-space">
			
		</div>
	</div>
);

export default IndexPage;
